import { defineComponent as c, computed as o, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "929bf023-d41a-4913-b03a-82d792ba1f16" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#929bf023-d41a-4913-b03a-82d792ba1f16)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "m0 378.3 254-37.1 258 37V512H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 256.1 252.2-33.3L512 256v122.4H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 133.7 249.7 97 512 133.7v122.4H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h512v133.7H0z"
}, null, -1), b = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ c({
  __name: "mu",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(n) {
    const t = n, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), a("title", p, d(t.flagName), 1)) : f("", !0),
        k,
        v,
        g,
        x
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=mu-da62ca3b.js.map
